import { Message } from 'element-ui'

const handleError = (_this, err) => {
  console.error(err)
  if (err?.message === 'Network Error') {
    _this.$Notice.error({
      title: 'Network Error.',
      duration: 8
    })
  } else if (err?.response) {
    const { status, statusText, data } = err.response
    if (status >= 500) {
      _this.$Notice.error({
        title: 'Error Notice',
        desc: `【${status}】${statusText}`,
        duration: 8
      })
    }

    if (data.code === 0) {
      _this.$message({
        message: data.msg,
        type: 'warning'
      })
    } else if (data.code !== 1001) {
      if (data.msg) {
        _this.$message({
          message: data.msg,
          type: 'error'
        })
      }
    }
  }
}
export default ({ app }, inject) => {
  // 异常提示
  inject('handleError', (_this, err) => handleError(_this, err))
}
